var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"button_clear_filter",attrs:{"type":"is-text","size":_vm.size},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v("\n  reload\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }